// src/hooks/useRequireAuth.js
import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { IS_DEMO } from "../App";
export const useRequireAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // DEMO → brak auth
    if (IS_DEMO) return;

    const unsub = onAuthStateChanged(auth, user => {
      if (!user) {
        navigate(`/admin/login`, { replace: true });
      }
    });

    return () => unsub();
  }, [navigate]);
};
